import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
                </div>
                <span className="text-lg font-heading font-bold text-background-50">玖玖视频</span>
              </div>
              <p className="text-sm leading-relaxed text-background-50/60">
                玖玖视频是一个高清流畅的在线视频平台，提供海量免费视频资源。支持多终端同步观看，随时随地畅享优质视频内容。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">视频分类</h4>
              <ul className="space-y-2.5">
                {categories.filter(c => c.slug !== 'all').slice(0, 6).map(cat => (
                  <li key={cat.slug}>
                    <Link to={`/category/${cat.slug}`} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
                <li><Link to="/category/documentary" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">纪录片</Link></li>
                <li><Link to="/category/education" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">教育频道</Link></li>
                <li><Link to="/category/tech" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">科技频道</Link></li>
                <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">关注我们</h4>
              <p className="text-sm text-background-50/60 mb-4">
                获取最新视频更新和平台动态
              </p>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-50/50">
              &copy; 2026 玖玖视频 版权所有 | 京ICP备XXXXXXXX号
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}